import React from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';

const BaseballMatchGameSpecial = observer(({ item }) => {
  const { special } = item;
  const { firstBaseOnBall, firstHomerun, firstStrikeOut } = special;

  return (
    <div className="special_board">
      <dl className="item">
        <dt>첫홈런</dt>
        <dd
          className={clsx(
            !!firstHomerun && firstHomerun.location === 'AWAY' && 'on'
          )}
        />
        <dd
          className={clsx(
            !!firstHomerun && firstHomerun.location === 'HOME' && 'on'
          )}
        />
      </dl>
      <dl className="item">
        <dt>첫삼진</dt>
        <dd
          className={clsx(
            !!firstStrikeOut && firstStrikeOut.location === 'AWAY' && 'on'
          )}
        />
        <dd
          className={clsx(
            !!firstStrikeOut && firstStrikeOut.location === 'HOME' && 'on'
          )}
        />
      </dl>
      <dl className="item">
        <dt>첫볼넷</dt>
        <dd
          className={clsx(
            !!firstBaseOnBall && firstBaseOnBall.location === 'AWAY' && 'on'
          )}
        />
        <dd
          className={clsx(
            !!firstBaseOnBall && firstBaseOnBall.location === 'HOME' && 'on'
          )}
        />
      </dl>
    </div>
  );
});

export default BaseballMatchGameSpecial;
